// extracted by mini-css-extract-plugin
export var hideEditor = "_jn-2";
export var infoIcon = "_jn-3";
export var label = "_jn-1";
export var labelContainer = "_jn-0";
export var readonlyText = "_jn-4";